export default __webpack_public_path__ + "static/media/022-intersection-2.2342839a.png";